/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="9.69"
        height="9.32"
        viewBox="0 0 9.69 9.32"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="m4.32.7 3.44 3.47H0v1h7.79L4.33 8.61l.71.7 4.65-4.62L5.02 0l-.7.7z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'ArrowRightAltIcon';

export default Icon;
